const baseurl=[
    
    // {
    //     apiurl:"${process.env.REACT_APP_API}api/"
    // }

    {
        apiurl:"${process.env.REACT_APP_API}website/"
    }
]


export default baseurl ;